import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CURRENT_INSTANCE } from '../../tenant';
import GenericModal from '../common/generic-modal';
import MarkdownRenderer from '../common/markdown-renderer';

function ConsentContent() {
  const { t } = useTranslation();
  const [showTerms, setShowTerms] = useState<boolean>(false);

  return (
    <>
      <GenericModal
        open={showTerms}
        onOpenChange={setShowTerms}
        title={t('terms.title')}
        description={CURRENT_INSTANCE.content.terms}
      />
      <MarkdownRenderer
        content={CURRENT_INSTANCE.content.disclaimer}
        onCodeClick={() => setShowTerms((prev) => !prev)}
      />
    </>
  );
}

export default ConsentContent;
